import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="mt-auto py-3 bg-modern-textDark">
      <div className="max-w-[85rem] mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-white text-center">Copyright 2025 {t('株式会社法研')}</p>
      </div>
    </footer>
  );
}

export default Footer;